module.exports = __webpack_public_path__ + "static/img/p2.ccb81ba3.png";